var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _vm.message.sender_type === "user"
      ? _c("div", { staticClass: "row mb-4" }, [
          _c(
            "div",
            { staticClass: "col-10 col-sm-10 col-md-9 col-lg-10 p-0" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "panel-quote-flush panel-quote card panel-quote-right"
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-body panel-dark" },
                    [
                      Number(_vm.message.message_type_id) === 1
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.replaceUrl(
                                  _vm.message.message
                                )
                              )
                            }
                          })
                        : Number(_vm.message.message_type_id) === 2
                        ? [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.message.image_xl,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: _vm.message.image_sm,
                                      expression: "message.image_sm"
                                    }
                                  ],
                                  staticClass: "img-fluid"
                                })
                              ]
                            )
                          ]
                        : [
                            _vm.center
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "embed-responsive embed-responsive-16by9"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "embed-responsive-item" },
                                      [
                                        _c(
                                          "gmap-map",
                                          {
                                            ref: "gmap",
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%"
                                            },
                                            attrs: {
                                              center: _vm.center,
                                              zoom: 14
                                            }
                                          },
                                          _vm._l(_vm.markers, function(
                                            marker,
                                            index
                                          ) {
                                            return _c("gmap-marker", {
                                              key: "marker" + index,
                                              attrs: {
                                                position: marker.position,
                                                icon: marker.icon
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                      _vm._v(" "),
                      _c("div", { staticClass: "message-time" }, [
                        _vm._v(
                          _vm._s(_vm._f("timeSpan")(_vm.message.create_date)) +
                            "\n            "
                        ),
                        parseFloat(_vm.message.is_read) === 1
                          ? _c("i", { staticClass: "fas fa-check-double" })
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-2 col-sm-2 col-md-3 col-lg-2 text-right p-0" },
            [
              _vm.user.picture
                ? _c("img", {
                    directives: [
                      {
                        name: "lazy",
                        rawName: "v-lazy",
                        value: _vm.user.picture,
                        expression: "user.picture"
                      }
                    ],
                    staticClass: "rounded-circle message-user-img",
                    attrs: { alt: "user image" }
                  })
                : _vm._e()
            ]
          )
        ])
      : _c("div", { staticClass: "row mb-4" }, [
          _c(
            "div",
            { staticClass: "col-2 col-sm-2 col-md-3 col-lg-2 text-left p-0" },
            [
              _c("div", { staticClass: "avatar-container small" }, [
                _c("div", {
                  class: [
                    "dot",
                    _vm.professional.active === 1 ? "active" : "inactive"
                  ]
                }),
                _vm._v(" "),
                _vm.professional
                  ? _c("img", {
                      directives: [
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: _vm.professional.picture,
                          expression: "professional.picture"
                        }
                      ],
                      staticClass: "rounded-circle message-user-img",
                      attrs: { alt: "cleaner image" }
                    })
                  : _vm._e()
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-10 col-sm-10 col-md-9 col-lg-10 p-0" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "panel-quote-flush panel-quote card panel-quote-left"
                },
                [
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      Number(_vm.message.message_type_id) === 1
                        ? _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.replaceUrl(
                                  _vm.message.message
                                )
                              )
                            }
                          })
                        : Number(_vm.message.message_type_id) === 2
                        ? [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.message.image_xl,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: _vm.message.image_sm,
                                      expression: "message.image_sm"
                                    }
                                  ],
                                  staticClass: "img-fluid"
                                })
                              ]
                            )
                          ]
                        : [
                            _vm.center
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "embed-responsive embed-responsive-16by9"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "embed-responsive-item" },
                                      [
                                        _c(
                                          "gmap-map",
                                          {
                                            ref: "gmap",
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%"
                                            },
                                            attrs: {
                                              center: _vm.center,
                                              zoom: 14
                                            }
                                          },
                                          _vm._l(_vm.markers, function(
                                            marker,
                                            index
                                          ) {
                                            return _c("gmap-marker", {
                                              key: "marker" + index,
                                              attrs: {
                                                position: marker.position,
                                                icon: marker.icon
                                              }
                                            })
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                      _vm._v(" "),
                      _c("div", { staticClass: "message-time" }, [
                        _vm._v(
                          _vm._s(_vm._f("timeSpan")(_vm.message.create_date)) +
                            "\n          "
                        )
                      ])
                    ],
                    2
                  )
                ]
              )
            ]
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-09f74f02", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f74f02","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/message/Message.vue
// module id = 1790
// module chunks = 0